<template>
  <md-dialog
      class="successDialog"
      :md-active.sync="options.showError"
  >
    <!-- TOP SUCCESS BOX -->
    <div class="error-box">
      <div class="error-left">
        <img src="@/assets/images/icons/error.svg" class="error-icon" />
        <span class="error-text" :class="{ 'no-id': !options.showSuccessTripId }" >
          {{ options.errorMsg }}
        </span>
      </div>

      <!-- Trip ID block -->
      <NezasaIdBox v-if="options.showSuccessTripId" :tripid="options.showSuccessTripId" />
    </div>

    <!-- ACTION BUTTONS -->
    <md-dialog-actions class="actions">
      <md-button class="md-raised secondary" @click="options.showError = false">
        <strong>{{ options.Lang.schließen }}</strong>
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import NezasaIdBox from '@/components/parts/NezasaIdBox.vue';
export default {
  name: "SuccessDialog",
  components: {
    NezasaIdBox,
  },
  props: {
    options: { type: Object, required: true },
    tripId: { type: String, required: false }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
    }
  }
};
</script>

<style scoped>
.successDialog {
  max-width: 900px !important;
  width: 900px !important;
  margin: auto;
  border-radius: 12px;
}

/* TOP BOX */
.error-box {
  background: #FFEBEE;
  padding: 40px 50px;
  padding-top: 57px;
  padding-bottom: 63px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 12px 12px 0 0;
}

/* LEFT SIDE */
.error-left {
  display: flex;
  align-items: center;
  gap: 15px;
}

.error-icon {
  width: 38px;
  height: 38px;
}

.error-text {
  font-size: 26px;
  font-weight: 500;
  width: 72%;
  line-height: 1; /* or 1.6 for more space */
}
/* When no Nezasa ID box exists */
.error-text.no-id {
  width: auto !important;
}
/* TRIP ID BOX */
.trip-box {
  background: #FFCDD5;
}

/* ACTION BUTTON ROW */
.actions {
  display: flex;
  justify-content: center;
  padding: 35px 0 45px;
  border-top: 1px solid #e8e8e8;
}
</style>
